import { render, staticRenderFns } from "./AppPagination.vue?vue&type=template&id=76358a82"
import script from "./AppPagination.vue?vue&type=script&lang=ts"
export * from "./AppPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports